import type { NotificationCategory, NotificationHistoryItem } from "./types";

/** Pure helpers for server notifications (member_notifications). */

export type MemberNotificationRow = {
  id: number;
  category: string;
  title: string;
  body: string | null;
  href: string | null;
  tag: string;
  occurrences: number | null;
  created_at: string;
  read_at: string | null;
};

/** "Julio Loja" + 3 grouped messages → "Julio Loja · 3 new". */
export const mapMemberNotification = (
  row: MemberNotificationRow,
): NotificationHistoryItem => ({
  id: String(row.id),
  category: row.category as NotificationCategory,
  title:
    (row.occurrences ?? 1) > 1
      ? `${row.title} · ${row.occurrences} new`
      : row.title,
  body: row.body ?? "",
  href: row.href ?? undefined,
  tag: row.tag,
  created_at: row.created_at,
  read: row.read_at != null,
});

/** The notification points at what this tab is showing right now. */
export const isViewingNotificationTarget = (
  entry: NotificationHistoryItem,
  location: { pathname: string; search: string },
  activeConversationId: string | number | null | undefined,
) => {
  if (!entry.href) return false;
  const [path, query = ""] = entry.href.split("?");
  const params = new URLSearchParams(query);
  const conversation = params.get("conversation");
  if (conversation && String(activeConversationId ?? "") === conversation) {
    return true;
  }
  if (location.pathname !== path) return false;
  // Same page; for record pages with ?thread / ?conversation, same target.
  const current = new URLSearchParams(location.search);
  for (const key of ["conversation", "thread"]) {
    if (params.get(key) && params.get(key) !== current.get(key)) return false;
  }
  return true;
};

export const LEADS_STALE_DAYS = 4;

export const summarizeLeadsDigest = (followUps: number, stale: number) =>
  [
    followUps
      ? `${followUps} follow-up${followUps === 1 ? "" : "s"} due`
      : null,
    stale
      ? `${stale} lead${stale === 1 ? "" : "s"} with no activity in ${LEADS_STALE_DAYS}+ days`
      : null,
  ]
    .filter(Boolean)
    .join(" · ");
